<template>
    <div class="allwidth">
        <img class="pointer" src="../assets/freevip1.jpg" width="100%" @click="$store.commit('showFreeVip')"/>
        <img src="../assets/freevip2.jpg" width="100%"/>
    </div>

</template>

<script>
export default {
    
    metaInfo() {
        return{
        title: '路上畅听领取七天免费VIP会员' + this.$store.state.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
}
</script>
<style scoped>
.pointer{cursor: pointer;}
.allwidth{padding: 0; margin: 0; overflow: hidden;}
    img{float: left;}
</style> 